import { v4 as uuidv4 } from "uuid";

export const commonRequestHeaders = () => ({
  "vf-country-code": "*",
  "channel-id": "PAF",
  "vf-ext-bp-id": uuidv4(),
  vf_int_caller_id: uuidv4(),
  "vf-trace-transaction-id": uuidv4(),
});
